import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

const getAllAffiliatesData = async (timezoneOffset?: number): Promise<string> => {
  const params = timezoneOffset !== undefined ? { timezoneOffset: timezoneOffset.toString() } : {};
  const res = await axiosInstance.get(`/api/affiliates/download`, { params });
  return res.data;
};

export const useGetAllAffiliatesData = () => {
  return useMutation({
    mutationFn: (timezoneOffset?: number) => getAllAffiliatesData(timezoneOffset),
  });
};
